import type { IrrigationDevice } from '@/lib/api/irrigation-devices-api'
import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'
import { twJoin } from '@/lib/utils'

type PumpView = {
    label: string
    variant: 'default' | 'secondary' | 'destructive' | 'outline'
    dot: string
}

/** Diễn giải trạng thái bơm của một bộ tưới thành nhãn hiển thị. */
export function pumpView(device: IrrigationDevice): PumpView {
    if (device.reading_state === 'unavailable') {
        return {
            label: m.irrigation_devices_unavailable(),
            variant: 'destructive',
            dot: 'bg-destructive',
        }
    }
    if (device.reading_state === 'no_data') {
        return {
            label: m.irrigation_devices_no_data(),
            variant: 'outline',
            dot: 'bg-muted-foreground',
        }
    }
    if (device.pump_on === true) {
        return {
            label: m.irrigation_devices_pump_on(),
            variant: 'default',
            dot: 'bg-primary-foreground',
        }
    }
    if (device.pump_on === false) {
        return {
            label: m.irrigation_devices_pump_off(),
            variant: 'secondary',
            dot: 'bg-muted-foreground',
        }
    }
    return {
        label: m.irrigation_devices_pump_unknown(),
        variant: 'outline',
        dot: 'bg-muted-foreground',
    }
}

/** Nhãn trạng thái bơm: có chấm màu và chữ, không chỉ dựa vào màu. */
export function IrrigationPumpBadge({ device }: { device: IrrigationDevice }) {
    const view = pumpView(device)
    return (
        <Badge variant={view.variant} className="gap-1.5">
            <span
                aria-hidden
                className={twJoin('size-1.5 rounded-full', view.dot)}
            />
            {view.label}
        </Badge>
    )
}
